import React from 'react';

const TermsOfUse = () => (
  <div className="min-h-screen bg-gradient-to-b from-white to-slate-50">
    <main className="pt-20 px-4 sm:px-6 lg:px-8 pb-24">
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="space-y-2">
          <h1 className="text-5xl font-bold text-slate-900">Terms of Service</h1>
          <p className="text-slate-600">Last Updated: January 2026</p>
        </div>

        <p className="text-lg text-slate-600 leading-relaxed border-l-4 border-blue-500 pl-4">
          Welcome to Mustan-Dev. These Terms of Service govern your access to and use of our website and services. By visiting this site or engaging with our services, you agree to be bound by these terms.
        </p>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">1. Acceptable Use</h2>
          <p className="text-slate-600">
            You agree to use this website and services only for lawful purposes and in a manner that does not infringe upon the rights of others or restrict their use and enjoyment. Prohibited behavior includes:
          </p>
          <ul className="space-y-2 text-slate-600 list-disc list-inside ml-2">
            <li>Harassing or causing distress or inconvenience to any person</li>
            <li>Transmitting obscene or offensive content</li>
            <li>Disrupting the normal flow of dialogue within our website or services</li>
            <li>Attempting to gain unauthorized access to systems or networks</li>
            <li>Scraping or bulk downloading content without permission</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">2. Intellectual Property Rights</h2>
          <div className="space-y-3 text-slate-600">
            <p>All content on this website—including but not limited to text, graphics, logos, images, code, design, and layout—is the property of Mustan-Dev or used with permission and is protected by international copyright laws.</p>
            <p><strong>You may not:</strong></p>
            <ul className="space-y-1 list-disc list-inside ml-2">
              <li>Reproduce, distribute, or transmit any content without written permission</li>
              <li>Modify or create derivative works from any content</li>
              <li>Use content for commercial purposes without authorization</li>
              <li>Remove or alter any proprietary notices, labels, or marks</li>
            </ul>
            <p><strong>You may:</strong> View and print content for personal, non-commercial use only.</p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">3. User-Generated Content</h2>
          <p className="text-slate-600">
            If you submit content to us through contact forms, emails, or project inquiries, you grant Mustan-Dev a non-exclusive license to use that content for responding to your inquiry, improving services, and internal analytics. You retain ownership of your content but authorize us to process and store it securely.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">4. Disclaimer of Warranties</h2>
          <p className="text-slate-600">
            This website and all services are provided on an "as-is" basis without warranties of any kind, either express or implied. We do not warrant that:
          </p>
          <ul className="space-y-1 text-slate-600 list-disc list-inside ml-2">
            <li>The site will be uninterrupted or error-free</li>
            <li>Defects will be corrected</li>
            <li>Content is accurate, complete, or reliable</li>
            <li>Viruses or harmful code are absent</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">5. Limitation of Liability</h2>
          <p className="text-slate-600">
            To the fullest extent permitted by law, Mustan-Dev shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of or inability to use the website or services, including but not limited to loss of data, revenue, or business opportunity.
          </p>
          <p className="text-slate-600">
            For service contracts, liability is limited to amounts explicitly documented in writing. Any claims must be brought within one year of the incident.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">6. Service Engagement & Contracts</h2>
          <div className="space-y-3 text-slate-600">
            <p>If you engage Mustan-Dev for development, design, or consulting services:</p>
            <ul className="space-y-2 list-disc list-inside ml-2">
              <li>A separate service agreement will be provided detailing scope, timeline, and payment terms</li>
              <li>All project deliverables are documented and agreed upon in writing before work begins</li>
              <li>Intellectual property ownership is specified in the individual service agreement</li>
              <li>Cancellation and refund policies are outlined in the contract</li>
            </ul>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">7. Third-Party Links</h2>
          <p className="text-slate-600">
            This website may contain links to third-party websites and services. Mustan-Dev is not responsible for the content, accuracy, or practices of external sites. Your use of third-party services is governed by their terms and policies.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">8. Payment Terms</h2>
          <p className="text-slate-600">
            For paid services, invoices and payment schedules are provided in the service agreement. Payment terms are typically net 30 days unless otherwise specified. Late payments may incur interest at 1.5% per month or the maximum rate allowed by law.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">9. Termination</h2>
          <p className="text-slate-600">
            Mustan-Dev reserves the right to terminate or suspend access to the website or services at any time, with or without cause, and without notice or liability. Termination of service agreements will be handled according to the specific contract terms.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">10. Modifications to Terms</h2>
          <p className="text-slate-600">
            We reserve the right to modify these Terms of Use at any time. Changes will be effective immediately upon posting to the website. Your continued use of the site constitutes acceptance of updated terms. Please review this page periodically.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">11. Governing Law</h2>
          <p className="text-slate-600">
            These Terms of Use are governed by and construed in accordance with applicable law, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">12. Contact Information</h2>
          <p className="text-slate-600">
            For questions about these Terms of Use or to discuss service agreements:
          </p>
          <div className="bg-slate-100 p-4 rounded-lg text-slate-700">
            <p><strong>Email:</strong> <a href="mailto:info@mustan.dev" className="text-blue-600 hover:underline">info@mustan.dev</a></p>
            <p><strong>Website:</strong> <a href="https://mustan.dev" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">mustan.dev</a></p>
          </div>
        </section>
      </div>
    </main>
  </div>
);

export default TermsOfUse;
